import Button from '@r1-frontend/ui-react/components/buttons/button';
import { DescribedCost } from '@r1-frontend/ui-react/components/costs';
import Characteristics from '@r1-frontend/ui-react/components/List/Characteristics';
import { TCharacteristicsProps } from '@r1-frontend/ui-react/components/List/Characteristics/Characteristics';
import { Pre } from '@r1-frontend/ui-react/components/typography/formatting';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4, Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as S from './styled';

interface IDesktopRouterCard {
    characteristics: TCharacteristicsProps[] | string,
    title: string | JSX.Element,
    description: string | JSX.Element,
    entityUriPath: string,
    price: number,
    period: number,
    onCostClick?: () => void,
    onButtonClick: () => void,

    isTestDrive?: boolean,
    isCredit?: boolean,
    previousPrice?: number,
    buttonName?: string,
}

const DesktopRouterCard = ({
    title,
    description,
    characteristics,
    entityUriPath,
    price,
    period,
    isTestDrive,
    isCredit,
    previousPrice,
    buttonName = 'Заказать',
    onCostClick,
    onButtonClick,
}: IDesktopRouterCard): JSX.Element => {
    return (
        <>
            <ListContainer $size={24} $direction={'column'}>
                <ListContainer $size={4} $direction={'column'}>
                    <Paragraph5 $color={COLORS.TextHint}>{description}</Paragraph5>
                    <H4 as={'a'} href={entityUriPath} $withIndent={false}>{title}</H4>
                    <S.Block>
                        {typeof characteristics === 'string'
                        ?   <S.DescriptionBlock>
                                <Paragraph4 as='div' $color={COLORS.GRAY_DARK} dangerouslySetInnerHTML={{ __html: characteristics }}/>
                            </S.DescriptionBlock>
                        :   <>
                                {characteristics.map(characteristic => (
                                    <Characteristics key={`Characteristic_${characteristic.title}`} {...characteristic} componentProps={{ $smaller: true }}/>
                                ))}
                            </>
                        }
                    </S.Block>
                </ListContainer>
                <S.DesktopFooter>
                    <DescribedCost
                        onClick={onCostClick}
                        isTestDrive={isTestDrive}
                        isCredit={isCredit}
                        installmentPeriod={period}
                        previousCost={previousPrice}
                        CostWrapper={(props) => <H4 as={'p'} $inline={true} $withIndent={false} {...props}/>}
                        DescriptionWrapper={(props) => <Pre $whiteSpace={'nowrap'} $withIndent={false}><Paragraph4 $smaller {...props}/></Pre>}
                    >
                        {price}
                    </DescribedCost>
                    <Button
                        bType={'primary'}
                        size={'small'}
                        onClick={onButtonClick}
                        data-test={'RouterCard_onAdd'}
                    >
                        {buttonName}
                    </Button>
                </S.DesktopFooter>
            </ListContainer>
        </>
    );
};

export default DesktopRouterCard;
